import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from 'routes/Logo';
import { UnknownParamsFunction } from 'shared/types/commonPropTypes';
import EditorLabel from './EditorLabel';

type HamburgerMenuProps = {
  toggleMenu: UnknownParamsFunction;
  navOpen: boolean;
  inEditor: boolean;
  team: any;
  paths: any;
};

export default (props: HamburgerMenuProps) => {
  const { toggleMenu, navOpen, team, paths, inEditor } = props;

  /* Brand and toggle get grouped for better mobile display */
  return (
    <div className="navbar-header">
      {team && (
        <button type="button" className="navbar-toggle" onClick={toggleMenu}>
          {!navOpen && (
            <span>
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </span>
          )}
          {navOpen && (
            <span>
              <span className="fa fa-times" />
            </span>
          )}
        </button>
      )}

      <NavLink to={paths.profileCharts}>
        <div className={`${inEditor ? 'flex w-[290px] ev-sm:w-[340px]' : ''}`}>
          <Logo className={`${inEditor ? 'mr-2' : ''}`} />
          {inEditor && <EditorLabel />}
        </div>
      </NavLink>
    </div>
  );
};
